import {
  Box,
  Stack,
  Typography,
  TextField,
  Divider,
} from '@atgfr8/atg-ui-tailwind';
import { Button } from '@components';
import {
  ContainerItem,
  ediConfigurationStore,
  setEdiConfigurationStore,
} from '@store/customers/customerDetails';
import { closeModal } from '@store/modals';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import {
  Accessor,
  Component,
  createEffect,
  createSignal,
  onMount,
} from 'solid-js';
import { produce } from 'solid-js/store';

type AssignedRuleModalProps = {
  selectedItem: () => {
    containerId: string;
    item: ContainerItem | null;
  } | null;
  initialData: {
    A: ContainerItem[];
    B: ContainerItem[];
  };
  keyToUpdate: keyof typeof ediConfigurationStore.ediData;
  triggerFunction: Accessor<boolean>;
  setTriggerFunction: () => void;
};

const AssignedRuleModal: Component<AssignedRuleModalProps> = (props) => {
  const [parameters, setParameters] = createSignal<string>('');

  onMount(() => setParameters(props.selectedItem()?.item?.parameters ?? ''));

  const save = () => {
    setEdiConfigurationStore(
      'ediData',
      props.keyToUpdate,
      produce((draft) => {
        const item = draft as ContainerItem[];
        const index = item.findIndex(
          (i) => i.id === props.selectedItem()?.item?.id,
        );
        if (props.selectedItem()?.containerId === 'A') {
          item[index].isAdded = item[index].isAdded ?? true;
          item[index].isDirty = true;
          item[index].isDeleted = false;
          item[index].parameters = parameters();
        }
      }),
    );
    closeModal('addOrEditParameter');
  };

  createEffect(() => {
    if (props.triggerFunction()) {
      save();
      props.setTriggerFunction();
    }
  });

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="caption">Name</Typography>
        <Typography variant="body2">
          {props.selectedItem()?.item?.name}
        </Typography>
      </Stack>
      <Stack spacing={0.5}>
        <Typography variant="caption">
          {props.selectedItem()?.containerId === 'A'
            ? 'Parameters'
            : 'Description'}
        </Typography>
        <Typography variant="body2">
          {props.selectedItem()?.containerId === 'A' ? (
            <TextField
              label=""
              fullWidth
              value={parameters()}
              onChange={(e: string) => {
                setParameters(e);
              }}
              dataTestId="assigned-rule-modal-parameters-textInput"
            />
          ) : (
            props.selectedItem()?.item?.ruleDescription
          )}
        </Typography>
      </Stack>
      <Divider />
      <Box display="flex" justifyContent="flex-end">
        <Button
          disabled={!Boolean(props.selectedItem()?.containerId === 'A')}
          variant="contained"
          color="primary"
          label="Save"
          onClick={save}
          dataTestId={formatDataTestId('Save', 'button')}
        />
      </Box>
    </Stack>
  );
};

export default AssignedRuleModal;
